export const HotelCategoryGuide = () => {
	return (
		<div className="space-y-2">
			<h5 className="text-base font-bold">宿泊施設のカテゴリ</h5>
			<div className="bg-bg-layer-100 space-y-4 rounded-md p-4">
				<div className="space-y-2">
					<p className="text-sm">
						Google無料予約リンクでは宿泊施設を<strong>「ホテル」</strong>、<strong>「民泊」</strong>、
						<strong>「屋外宿泊施設」</strong>
						の3つのカテゴリに分類しています。
					</p>
					<p className="text-sm">どのカテゴリに分類されるかは、Googleによって最終的に判断されます。</p>
				</div>

				<div className="space-y-2">
					<p className="text-sm font-medium">簡易的なチェックの条件：</p>
					<ul className="list-inside list-disc space-y-1 pl-2 text-sm">
						<li>宿泊客を受け入れている</li>
						<li>フロントデスクがある、または施設常駐のスタッフがいる</li>
						<li>宿泊施設とビジネス拠点の住所が公開されている</li>
					</ul>
					<div className="space-y-0.5 rounded bg-zinc-50 p-3 text-xs text-zinc-800">
						<p className="font-medium">判定の目安：</p>
						<p>全ての条件を満たす場合：ホテルカテゴリの可能性が高い</p>
						<p>1つでも満たさない場合：民泊・屋外宿泊施設の可能性が高い</p>
					</div>
				</div>

				<div>
					<a
						href="https://support.google.com/hotelprices/answer/9970971?hl=ja"
						target="_blank"
						rel="noopener noreferrer"
						className="text-sm text-link-400 underline-offset-4 hover:underline"
					>
						Googleの公式ドキュメントで詳細を確認する
					</a>
				</div>
			</div>
		</div>
	);
};
